import { render, staticRenderFns } from "./email-confirmed-page.vue?vue&type=template&id=52817cf2&scoped=true"
import script from "./email-confirmed-page.vue?vue&type=script&lang=ts"
export * from "./email-confirmed-page.vue?vue&type=script&lang=ts"
import style0 from "./email-confirmed-page.vue?vue&type=style&index=0&id=52817cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52817cf2",
  null
  
)

export default component.exports